export const styles = {
  loaderWrap: {
    display: 'flex',
    justifyContent: 'center',
  },
};
